import { IBooking } from "dataModels/b2b";
import React from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { AppUserRole, CalendarSlotStatus, DATE_FORMAT, DsLayout, SnamPlantKey, TIME_FORMAT } from "shared/constants";
import { Container, Row, Col } from "react-grid-system";
import styles from "views/b2bView/styles/bookingDataStyles.module.css";
import { getBookingBadgeStatus } from "views/b2bView/shared/bookingBadgeStatus";
import DsBadge from "components/DsBadge";
import { getJarvisBadgeStatus } from "views/b2bView/shared/jarvisBadgeStatus";
import { useSelector } from "react-redux";
import { appStore, RootState } from "state/appStore";
import { NotificationBadge, Output } from "@ds/ds-snam/react";
import { IParseDateFormatType, parseDateForDS } from "shared/utils/dateUtils";
import { AppUser } from "ooAuth2/appUser";
import useAppUser from "hooks/useAppUser";

interface IBookingSlotDetailProps {
    bookingData: IBooking
}
/** Shared component to show booking slot detail fragment only
 * Used by booking form data and booking form review
 */
const BookingSlotDetail: React.FC<IBookingSlotDetailProps> = (props): JSX.Element => {
    const { bookingData } = props;
    const { t } = useTranslation(['b2b', 'app']);
    const appUser: AppUser | undefined = useAppUser();
    const appUserRole: AppUserRole | undefined = appUser?.getRole();
    const layoutMode = useSelector((state:RootState)=>{
        return state.dsLayout.mode;
    })
    const userPlants = appUser!.getPlants(); // Ottieni il vettore dall'utente
    const plantIdValue: string|undefined = appStore.getState().plant.plantId;
    return bookingData ?
        <Container className={styles.dataContainer} style={{marginBottom:'20px', marginTop:'12px' ,background: layoutMode===DsLayout.DARK_MODE?"#081C3E":"white"}}>
            {/** dettagli slot */}
            <Row>
                <Col>
                    <div className="formSubTitle" style={{ marginBottom: "24px" }}>
                        {t('booking.bookingData.headers.0')}
                    </div>
                </Col>
            </Row>
            <Row>
                {/** code iup short*/}
                <Col className={styles.dataContainerColumn}>
                    <Output
                        outputTitle={t('booking.bookingData.headers.1')}
                        outputText={bookingData.reservationCode}
                        style={{marginBottom:'16px'}}
                    ></Output>
                    {/*<div style={{color: layoutMode===DsLayout.DARK_MODE?"white":"#444C55"}}>{t('booking.bookingData.headers.1')}</div>
                    <div style={{color: layoutMode===DsLayout.DARK_MODE?"white":"black"}}>{bookingData.codeIup}</div>*/}
                </Col>
                {/** code iup long*/}
                {/*<Col className={styles.dataContainerColumn}>
                    <Output
                        outputTitle={t('booking.bookingData.headers.1')}
                        outputText={bookingData.codeIup}
                        style={{marginBottom:'16px'}}
                    ></Output>
                </Col>*/}
                <Col></Col>
                <Col></Col>
            </Row>
            <Row>
                {/** data */}
                <Col className={styles.dataContainerColumn}>
                    <Output
                        outputTitle={t('booking.bookingData.headers.2')}
                        outputText={parseDateForDS(moment.unix(bookingData.date).format(DATE_FORMAT),IParseDateFormatType.DATE_FORMAT1)}
                        style={{marginBottom:'16px'}}
                    ></Output>
                    {/*<div style={{color: layoutMode===DsLayout.DARK_MODE?"white":"#444C55"}}>{t('booking.bookingData.headers.2')}</div>
                    <div style={{color: layoutMode===DsLayout.DARK_MODE?"white":"black"}}>{moment.unix(bookingData.date).format(DATE_FORMAT)}</div>*/}
                </Col>
                {/** orario */}
                <Col className={styles.dataContainerColumn}>
                    <Output
                        outputTitle={t('booking.bookingData.headers.3')}
                        outputText={bookingData.time}
                        style={{marginBottom:'16px'}}
                    ></Output>
                    {/*<div style={{color: layoutMode===DsLayout.DARK_MODE?"white":"#444C55"}}>{t('booking.bookingData.headers.3')}</div>
                    <div style={{color: layoutMode===DsLayout.DARK_MODE?"white":"black"}}>{bookingData.time}</div>*/}
                </Col>
                {/** stato prenotazione */}
                <Col className={styles.dataContainerColumn}>
                    
                    <div  style={{color: layoutMode===DsLayout.DARK_MODE?"white":"#444C55",marginBottom:'5px'}}>{t('booking.bookingData.headers.4')}</div>
                    <div className={styles.badgeContainer} style={{color: layoutMode===DsLayout.DARK_MODE?"white":"black"}}>
                        {(bookingData.status!==CalendarSlotStatus.CANCELLED && bookingData.status!==CalendarSlotStatus.SLOT_DELETED && bookingData.status!==CalendarSlotStatus.VACANT) ?
                            <>
                                <DsBadge 
                                    isSmall={true}
                                    notificationStatus={getBookingBadgeStatus(bookingData.status)} 
                                    backgroundColor={getBookingBadgeStatus(bookingData.status)==="custom"?"#320216":undefined}
                                />
                                {t('booking.bookingData.bookingStatus.' + bookingData.status)}
                                {
                                    (bookingData.status===CalendarSlotStatus.CONFIRMED && 
                                    bookingData.freezingTimeStamp > Date.now()/1000) &&
                                    t('booking.bookingData.bookingStatus.11')
                                }
                            </>
                        :
                            <>
                                {bookingData.status===CalendarSlotStatus.CANCELLED ?
                                    <>
                                        <NotificationBadge
                                            notificationStatus={"custom"}
                                            badgeVariant={"default"}
                                            badgeAriaLabel={"Badge aria label"}
                                            isSmall={true}
                                            backgroundColor={'#9A0557'}
                                            badgeText={t('booking.bookingList.tableLegend.4',{ns:'b2b'})}
                                        />
                                        <span className="legendaLabel--contract">
                                            {t('booking.bookingList.tableLegend.4',{ns:'b2b'})}
                                        </span>
                                    </>
                                :
                                    <>
                                        {bookingData.status===CalendarSlotStatus.VACANT ?
                                            <>
                                                <NotificationBadge
                                                    notificationStatus={"custom"}
                                                    badgeVariant={"default"}
                                                    badgeAriaLabel={"Badge aria label"}
                                                    isSmall={true}
                                                    backgroundColor={"#267f8f"}
                                                    badgeText={t('booking.bookingList.tableLegend.6',{ns:'b2b'})}
                                                />
                                                <span className="legendaLabel--contract">
                                                    {t('booking.bookingList.tableLegend.6',{ns:'b2b'})}
                                                </span>
                                            </>
                                        :
                                            <>
                                                <NotificationBadge
                                                    notificationStatus={"custom"}
                                                    badgeVariant={"default"}
                                                    badgeAriaLabel={"Badge aria label"}
                                                    isSmall={true}
                                                    backgroundColor={'#4956B0'}
                                                    badgeText={t('booking.bookingList.tableLegend.5',{ns:'b2b'})}
                                                />
                                                <span className="legendaLabel--contract">
                                                    {t('booking.bookingList.tableLegend.5',{ns:'b2b'})}
                                                </span>
                                            </>
                                        }
                                    </>
                                }
                            </>
                        }   
                        

                    </div>
                </Col>
                
                
                {/*<Col className={styles.dataContainerColumn}>
                    <Output
                        outputTitle="Long Term"
                        outputText={(bookingData.longTermTimeStamp && moment.unix(bookingData.longTermTimeStamp).format(DATE_FORMAT) )+" - "+ (bookingData.longTermTimeStamp && moment.unix(bookingData.longTermTimeStamp).format(TIME_FORMAT))}
                        style={{marginBottom:'16px'}}
                    ></Output>
                </Col>*/}

                {((appUserRole===AppUserRole.ACCESS_STAFF || appUserRole===AppUserRole.ADMIN) && (userPlants?.includes(Number(SnamPlantKey.PIGNATARO))) && bookingData.reservationCode.includes("B") ) ?
                    <Col className={styles.dataContainerColumn}>
                        <Output
                            outputTitle={t('booking.bookingData.headers.37')}
                            outputText={(bookingData.accessCode && bookingData.accessCode!== null && bookingData.accessCode!==undefined) ? bookingData.accessCode.toString() : '-'}
                            style={{marginBottom:'16px'}}
                        ></Output>
                    </Col>
                :
                    <Col></Col>
                }
                
            </Row>
            
            {appUserRole!==AppUserRole.ACCESS_STAFF &&<>
            <Row style={{marginTop:'20px'}}>
                <Col className={styles.dataContainerColumn}>
                    <Output
                        outputTitle={"Freezing date" +" "+ t('booking.bookingData.headers.32')}
                        outputText={(bookingData.freezingTimeStamp && moment.unix(bookingData.freezingTimeStamp).format(DATE_FORMAT))+" - "+(bookingData.freezingTimeStamp && moment.unix(bookingData.freezingTimeStamp).format(TIME_FORMAT))}
                        style={{marginBottom:'16px'}}
                    ></Output>
                </Col>
                <Col className={styles.dataContainerColumn}>
                    <Output
                        outputTitle={"Freezing date" +" "+ t('booking.bookingData.headers.31')}
                        outputText={(bookingData.salesFreezingTimeStamp && moment.unix(bookingData.salesFreezingTimeStamp).format(DATE_FORMAT))+" - "+(bookingData.salesFreezingTimeStamp && moment.unix(bookingData.salesFreezingTimeStamp).format(TIME_FORMAT))}
                        style={{marginBottom:'16px'}}
                    ></Output>
                </Col>
                <Col></Col>
                <Col></Col>
            </Row>
            <Row style={{marginTop:'20px'}}>
                <Col className={styles.dataContainerColumn}>
                    <Output
                        outputTitle={t('booking.bookingData.headers.41')}
                        outputText = {bookingData.insertUserName?bookingData.insertUserName:'-'}
                        style={{marginBottom:'16px'}}
                    ></Output>
                </Col> 
            </Row>
            

            {/** Jarvis */}
            <Row>
                <Col>
                    <div className="formSubTitle" style={{ margin: "24px 0 24px", fontFamily: "Lato, Lato-local, sans-serif", fontSize: "20px", fontWeight: 700 }}>
                        {t('booking.bookingData.headers.5')}
                    </div>
                </Col>
            </Row>
            <Row>
                {/* Gnl */}
                <Col md={3} className={styles.dataContainerColumn}>
                    <div style={{color: layoutMode===DsLayout.DARK_MODE?"white":"#444C55",marginBottom:'5px'}}>{t('booking.bookingData.headers.6')}</div>
                    <div className={styles.badgeContainer} style={{color: layoutMode===DsLayout.DARK_MODE?"white":"black"}}>
                        <DsBadge isSmall={true} notificationStatus={plantIdValue===SnamPlantKey.PIGNATARO? getJarvisBadgeStatus(bookingData.shipperAggrAvailable):getJarvisBadgeStatus(bookingData.jarvisAvailable)} />
                        {t('booking.bookingData.jarvisStatus.' + (plantIdValue===SnamPlantKey.PIGNATARO?bookingData.shipperAggrAvailable:bookingData.jarvisAvailable))}
                    </div>
                </Col>
                {/* Shipper */}
                <Col md={3} className={styles.dataContainerColumn}>
                    <div style={{color: layoutMode===DsLayout.DARK_MODE?"white":"#444C55",marginBottom:'5px'}}>{t('booking.bookingData.headers.7')}</div>
                    <div className={styles.badgeContainer} style={{color: layoutMode===DsLayout.DARK_MODE?"white":"black"}}>
                        <DsBadge isSmall={true} notificationStatus={plantIdValue===SnamPlantKey.PIGNATARO?getJarvisBadgeStatus(bookingData.shipperAggrShipper):getJarvisBadgeStatus(bookingData.jarvisShipper)} />
                        {t('booking.bookingData.jarvisStatus.' + (plantIdValue===SnamPlantKey.PIGNATARO?bookingData.shipperAggrShipper:bookingData.jarvisShipper))}
                    </div>
                </Col>
                {/* Jarvis ACK */}
                {/*(bookingData.jarvisAck && bookingData.jarvisAck!== undefined) && 
                <Col md={3} className={styles.dataContainerColumn}>
                    <div style={{color: layoutMode===DsLayout.DARK_MODE?"white":"#444C55",marginBottom:'5px'}}>{t('booking.bookingData.headers.36')}</div>
                    <div className={styles.badgeContainer} style={{color: layoutMode===DsLayout.DARK_MODE?"white":"black"}}>
                        <DsBadge isSmall={true} notificationStatus={bookingData.jarvisAck===true?"confirm":"error"} />
                        {t('booking.bookingData.jarvisStatus.' + bookingData.jarvisAck)}
                    </div>
                </Col>*/}
            </Row>
            </>}
        </Container>
        :
        <></>

}
export default BookingSlotDetail;